import { Button, Modal } from 'react-bootstrap';
import { useTheme } from 'styled-components';

import TdasLogo from '../../../assets/svg/tdas.svg';
import { StyledLinkButton, StyledModalHeader } from '../../Styled';
import WhiteSpinner from '../../WhiteSpinner';

const Intro = (props) => {
  const theme = useTheme();
  return (
    <>
      <StyledModalHeader closeButton>
        <img alt="Turn Down and Save" src={TdasLogo} />
      </StyledModalHeader>
      <Modal.Body className="px-4 pb-3">
        <h1 className="mb-4 text-left">Turn Down and Save, with {theme.language.appName}</h1>
        <p className="mb-4">
          Get rewarded for using less energy, at carbon intensive times. Our winter Turn Down and Save scheme rewards
          users for using less electricity when the demand is highest, in a number of national energy-saving events.
          During these events, participating households try to use less electricity than normal. If you’re successful,
          you’ll receive a reward for each kilowatt hour less than normal that you use.
        </p>
        <Button onClick={props.onNext} disabled={props.loadingLoopAccount} className="w-100">
          {props.loadingLoopAccount ? <WhiteSpinner /> : 'Get started'}
        </Button>
        <StyledLinkButton className="mt-3 w-100" variant="link" onClick={props.onHide}>
          No thanks, not right now
        </StyledLinkButton>
      </Modal.Body>
    </>
  );
};
export default Intro;
